import store from "../redux/store";
import { LOG_SERVER_URL, REDUX_SERVER_URL } from "../constants";

export default async function fpLog(details) {
  if (typeof details === "string") {
    details = {
      message: details,
    };
  }
  const currentState = store.getState();
  const userData = currentState?.userData;
  const chatData = currentState?.chatData;
  const fpAppV3Data = currentState?.fpAppV3Data;
  const fpAppV4Data = currentState?.fpAppV4Data;

  let userEmail = userData?.userEmail;
  let chatId = chatData?.chatId;
  let sessionId = sessionStorage.getItem("sessionId");
  let userCurrentTime = getTimeStr();

  if (!userEmail) {
    userEmail = localStorage.getItem("userEmail");
  }

  details = {
    ...details,
    userEmail,
    chatId,
    sessionId,
    userCurrentTime,
    workspaceId: fpAppV3Data?.workspaceId || fpAppV4Data?.workspaceId,
    userAgent: navigator.userAgent,
    webpageCurrentUrl: window.location.href,
  };

  if (chatId) {
    details = {
      ...details,
      chatTabs: `<${REDUX_SERVER_URL}/getTabsForChatId?chatId=${chatId}|View Chat Tabs>`,
      chatMessages: `<https://stage-3-user-chat.d3qmmak2wjdlte.amplifyapp.com/blueBucket9722?email=&chatId=${chatId}|View Chat Messages>`,
      completeChat: `<https://stage.finpilotai.com/chat/share?chatId=${chatId}|View Complete Workspace>`,
    };
  }

  if (!details.logType) details.logType = "INFO";

  if (
    window.location.hostname === "localhost" ||
    window.location.hostname.includes("stage")
  ) {
    if (details.logType === "ERROR") console.error(details);
    // else console.log(details);
    // if (details.message) console.log("message: ", details.message);
    // log(details);
  } else {
    if (details.logType === "ERROR") console.error(details);

    log(details);
  }
}

async function log(details) {
  return;
}

function getTimeStr() {
  const now = new Date();
  const dateOptions = { year: "numeric", month: "short", day: "numeric" };

  const ptDateStr = now.toLocaleDateString("en-US", dateOptions);
  const ptTimeStr = now.toLocaleTimeString("en-US");

  return `${ptDateStr} | ${ptTimeStr}`;
}
